<template>
    <v-app-bar 
        height="45" 
        app 
        color="page-color"
        :class="{ 'rounded-tl-xl': !$vuetify.breakpoint.mobile }"
        class="" 
        style="box-shadow: none"
    >
		<!-- dialogChangeData -->
		<!-- <v-dialog v-model="dialogChangeData" width="400">
			<v-card>
				<v-card-title>
					Change Password
				</v-card-title>

				<v-card-text>
					<v-text-field
						v-model="newPassword"
					/>
				</v-card-text>

				<v-card-actions>
					<v-btn>
						Save
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog> -->
        <!-- title -->
		<div class="d-flex flex-grow-1">
            <div v-if="$route.name === 'features-page'" class="mr-13">
                <h3 class="mr-15 ml-4">Forsa</h3>
            </div>
			<h3 class="text--color  Urbanist-font">
				{{ $route.name !== 'login' ?  getRouteTitle() : '' }}
			</h3>
		</div>
        
        <v-spacer />	
        <div class="d-flex align-center">
            <v-btn icon @click="changeTheme()">
                <v-icon color="primary" v-if="!$vuetify.theme.dark"> mdi-white-balance-sunny  </v-icon>
                <v-icon v-else> mdi-weather-night  </v-icon>
            </v-btn>
            
        </div>
        
        <v-menu
            offset-y
        >
            <template v-slot:activator="{ on ,attr }">
                <v-btn
                    v-bind="attr"
                    v-on="on"
                    elevation="0"
                    color="transparent"
                    class="text-none text-start profile-btn"
                >
                    <v-row justify="end">
                        <v-col cols="auto" align-self="center" class="py-0 px-0">
                            <div class="">
                                <!-- <img
									v-if="profilePicUrl !== null || profilePicUrl !== undefined"
                                    :src="`${profilePicUrl}`"
                                    width="35"
                                    cover
                                    height="35"
                                    class="rounded-circle"
                                /> -->

								<img
                                    src="@/assets/im.png"
                                    width="35"
                                    cover
                                    height="35"
                                    class="rounded-circle"
                                />
                            </div>
                        </v-col>
                        <v-col cols="auto" align-self="center" class="px-0 py-0">
                          
                            <div>
                                <h4 class="mx-3 zain-bold" > {{ self.name }} </h4> 
                                <h5 class="mx-3 zain-bold"> {{ userTypeArray.find(c => c.id === self.userType).name }}</h5>
                            </div>
                        </v-col>
                        <v-col cols="auto" align-self="center" class="px-0 py-0">
                            <v-btn icon >
                                <v-icon class="px-3"> mdi-menu-down</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>						
                </v-btn>
            </template>

            <v-list>
                <v-list-item dense @click="logout()">
                    <v-list-item-icon> <v-icon> mdi-logout </v-icon> </v-list-item-icon>
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-if="type === userType.Administrative"
                    @click="$emit('go-profile', $event.target.value)"
                    dense
                >
                    <v-list-item-icon> 
                        <v-icon> mdi-swap-horizontal </v-icon> 
                    </v-list-item-icon>
                    <v-list-item-title> Account conversion </v-list-item-title>
                </v-list-item>

                <!-- <v-list-item dense @click="dialogChangeData = true">
                    <v-list-item-icon> <v-icon> mdi-logout </v-icon> </v-list-item-icon>
                    <v-list-item-title>Change password</v-list-item-title>
                </v-list-item> -->
            </v-list>
        </v-menu>
    </v-app-bar>
</template>
<script>
import { userType, userTypeArray } from '@/helper/enum';
import { mapState } from 'vuex';
export default {
	data () {
		return {
			profile: false,
			dialogChangeData: false,
			userType,
			userTypeArray
			// changePassword
		}
	},
	computed: {
		...mapState({
			username: state => state.auth.self.name,
			type: state => state.auth.self.userType,
			authentication: state => state.auth.authentication,
			// profilePicUrl: state => state.users.myData.employee.profilePicUrl,
			self: state => state.auth.self
		})
	},
	methods: {
		getRouteTitle () {
			const title = this.$route.meta.title;
			// const title = translateKey ? this.$t(`routes.${translateKey}`) : null;
			// if (this.$route.params.type) {
			return title;
			// console.log(this.$route.meta.title)
			// } else {
			// 	return title
			// }
		},

		logout () {
			this.$store.dispatch('auth/logout').then(() => {
				this.$router.push({
					name: 'login'
				})
			})
		},

		changeTheme () {
			const dark = this.$vuetify.theme.dark
			this.$vuetify.theme.dark = !dark
			localStorage.setItem('dark', (!dark))
		}
	}
}
</script>
<style>
.Urbanist-font {
  font-family: 'Urbanist';
}
</style>
